module.exports = __webpack_public_path__ + "img/观测资料-小标题@2x.ff1c584b.png";